// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
i[data-v-091cbc9b] {
  transition: ease-in-out 0.25s;
}
.flip[data-v-091cbc9b]{
  transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./ClientApp/components/kanban/modal/attributedefinitions/VueFormBuilder/Chevron.vue"],"names":[],"mappings":";AAKA;EACA,6BAAA;AACA;AACA;EACA,yBAAA;AACA","sourcesContent":["<template>\r\n  <i class=\"fa fa-chevron-down\" :class=\"{flip : !down}\" />\r\n</template>\r\n\r\n<style scoped>\r\ni {\r\n  transition: ease-in-out 0.25s;\r\n}\r\n.flip{\r\n  transform: rotate(180deg);\r\n}\r\n</style>\r\n\r\n<script lang=\"ts\">\r\nimport Vue from 'vue';\r\nimport { Component, Prop } from 'vue-property-decorator';\r\n\r\n@Component({})\r\nexport default class Chevron extends Vue {\r\n  @Prop({ required: true })\r\n  down!: boolean;\r\n}\r\n</script>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
